import {
  createContext,
  ReactElement,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from "react";

import { Category } from "../generated/gql/graphql";
import useCategories from "../hooks/query/use-categories";
import { emptyFn } from "../utils/provider";

type CategoryProviderContextType = {
  categories: Category[];
  refetch(): Promise<void>;
};

export const CategoryContext = createContext<CategoryProviderContextType>({
  categories: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/ban-ts-comment
  // @ts-ignore
  refetch: emptyFn,
});

type Props = {
  children: ReactNode | ReactNode[];
};

export default function CategoryProvider(props: Props): ReactElement {
  const { children } = props;

  const [categories, setCategories] = useState<Category[]>([]);
  const { data, refetch } = useCategories();

  useEffect(() => {
    if (!data) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!data.categories) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setCategories(data.categories.items);
  }, [data]);

  async function internalRefetch(): Promise<void> {
    await refetch();
  }

  const values = useMemo(
    () => ({
      categories,
      refetch: internalRefetch,
    }),
    [categories]
  );

  return (
    <CategoryContext.Provider value={values}>
      {children}
    </CategoryContext.Provider>
  );
}
